import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import Button from "../../../../ui/molecules/button";
import { Calendar } from "../../../../ui/molecules/calendar";
import { InfoBox } from "../../../../ui/molecules/infoBox";
import Input from "../../../../ui/molecules/input";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { SelectCustom } from "../../../../ui/molecules/select";
import { SingleCheckbox } from "../../../../ui/molecules/SingleCheckbox";
import TextArea from "../../../../ui/molecules/textArea";
import { GGNotificationTypeOptions, GGStandardOptionOptions, GGStandardOptions, GGStandardSubfieldOptions, GGValutationResultOptions } from "../../../../utils";
import { GGNotificationUpdate, resetGGNotificationUpdateStatus, setGGNotUpdateCoopModule, setGGNotUpdateEntryProtocolId, setGGNotUpdateGraspModule, setGGNotUpdateOtherType, setGGNotUpdateSpringModule, setGGNotUpdateStandard, setGGNotUpdateStandardOptions, setGGNotUpdateStandardSubfield, setGGNotUpdateType, setGGNotUpdateValutationDate, setGGNotUpdateValutationNote, setGGNotUpdateValutationResult } from "../dataservice/slice";

export function GlobalGapDatiGenerali() {
    const dispatch = useAppDispatch()
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const [GRASPFlag, setGRASPFlag] = useState<boolean>(false)
    const [COOPFlag, setCOOPFlag] = useState<boolean>(false)
    const [SPRINGFlag, setSPRINGFlag] = useState<boolean>(false)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        const req = ggNotificationState.ggNotificationUpdateRequest
        setGRASPFlag(req.graspModule!)
        setCOOPFlag(req.coopModule!)
        setSPRINGFlag(req.springModule!)

    }, [ggNotificationState.ggNotificationUpdateRequest])

    useEffect(() => {
        if (ggNotificationState.ggNotificationUpdateStatus === 'successfully') {
            dispatch(resetGGNotificationUpdateStatus())
            setShowSuccess(true)
        }
    }, [ggNotificationState.ggNotificationUpdateStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="notify-container">
                <div className='notify-header'>
                    <div className='text-left'>
                        <span className='notify-title-bold' style={{ color: '#fff' }}>Domanda </span>
                        <span className='notify-title-bold' style={{ color: '#74A4A9' }}>/</span>
                        <span className='notify-title-bold' style={{ color: '#d9e6e8' }}> Riepilogo</span>
                    </div>
                </div>

                <div style={{ padding: '24px' }}>

                    <div className="pb-5">
                        <ProtocolSearch
                            type="entry"
                            defaultValue={ggNotificationState.ggNotificationUpdateRequest.entryProtocolId}
                            onSelect={(value) => dispatch(setGGNotUpdateEntryProtocolId(value))}
                        />
                    </div>

                    <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'flex-end' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left notify-text-bold'>
                                Tipologia
                            </div>
                            <SelectCustom
                                placeholder='Seleziona tipologia...'
                                value={ggNotificationState.ggNotificationUpdateRequest.type}
                                options={GGNotificationTypeOptions}
                                onChange={(value) => dispatch(setGGNotUpdateType(value))}
                            />
                        </div>

                        <div style={{ flex: '0.5' }}>
                            <div className='text-left notify-text-bold'>
                                Tipologia Altro
                            </div>
                            <Input
                                placeholder='Specifica tipologia altro...'
                                value={ggNotificationState.ggNotificationUpdateRequest.otherType}
                                onChangeText={(text) => dispatch(setGGNotUpdateOtherType(text))}
                            />
                        </div>
                    </div>

                    <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.33' }}>
                            <div className='text-left notify-text-bold'>
                                Standard
                            </div>
                            <SelectCustom
                                placeholder='Seleziona standard...'
                                value={ggNotificationState.ggNotificationUpdateRequest.standard}
                                options={GGStandardOptions}
                                onChange={(value) => dispatch(setGGNotUpdateStandard(value))}
                            />
                        </div>

                        <div style={{ flex: '0.33' }}>
                            <div className='text-left notify-text-bold'>
                                Standard Sottocampo
                            </div>
                            <SelectCustom
                                placeholder='Seleziona sottocampo...'
                                value={ggNotificationState.ggNotificationUpdateRequest.standardSubfield}
                                options={GGStandardSubfieldOptions}
                                onChange={(value) => dispatch(setGGNotUpdateStandardSubfield(value))}
                            />
                        </div>

                        <div style={{ flex: '0.33' }}>
                            <div className='text-left notify-text-bold'>
                                Standard Opzione
                            </div>
                            <SelectCustom
                                placeholder='Seleziona opzione...'
                                value={ggNotificationState.ggNotificationUpdateRequest.standardOption}
                                options={GGStandardOptionOptions}
                                onChange={(value) => dispatch(setGGNotUpdateStandardOptions(value))}
                            />
                        </div>
                    </div>

                    <div className="pb-5 pt-3" style={{ display: 'flex', gap: '72px', borderBottom: '1px solid #d9e6e8' }}>
                        <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                            <div className='text-left notify-text-bold'>
                                Modulo GRASP
                            </div>
                            <SingleCheckbox
                                label=''
                                checked={GRASPFlag}
                                setChecked={(value) => {
                                    dispatch(setGGNotUpdateGraspModule(value))
                                    setGRASPFlag(value)
                                }}
                            />
                        </div>

                        <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                            <div className='text-left notify-text-bold'>
                                Modulo COOP Italia
                            </div>
                            <SingleCheckbox
                                label=''
                                checked={COOPFlag}
                                setChecked={(value) => {
                                    dispatch(setGGNotUpdateCoopModule(value))
                                    setCOOPFlag(value)
                                }}
                            />
                        </div>

                        <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                            <div className='text-left notify-text-bold'>
                                Modulo Spring
                            </div>
                            <SingleCheckbox
                                label=''
                                checked={SPRINGFlag}
                                setChecked={(value) => {
                                    dispatch(setGGNotUpdateSpringModule(value))
                                    setSPRINGFlag(value)
                                }}
                            />
                        </div>
                    </div>

                    <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left notify-text-bold'>
                                Data Valutazione
                            </div>
                            <Calendar
                                selected={ggNotificationState.ggNotificationUpdateRequest.valutationDate}
                                onChange={(date) => dispatch(setGGNotUpdateValutationDate(date))}
                            />
                        </div>

                        <div style={{ flex: '0.5' }}>
                            <div className='text-left notify-text-bold'>
                                Esito Valutazione
                            </div>
                            <SelectCustom
                                placeholder='Seleziona modulo...'
                                value={ggNotificationState.ggNotificationUpdateRequest.valutationResult}
                                options={GGValutationResultOptions}
                                onChange={(value) => dispatch(setGGNotUpdateValutationResult(value))}
                            />
                        </div>
                    </div>

                    <div className="pb-5">
                        <div className="pb-5">
                            <InfoBox
                                color="green"
                                content={[
                                    { title: 'Telefono/Cellulare', label: '3406502879' },
                                    { title: 'Posta Elettronica', label: 'test@test.it' },
                                    { title: 'PEC', label: 'pec@pec.it' },
                                ]}
                            />
                        </div>
                        <div>
                            <div className='text-left notify-text-bold'>
                                Esito Valutazione
                            </div>
                            <TextArea
                                value={ggNotificationState.ggNotificationUpdateRequest.valutationNote}
                                onChangeText={(text) => dispatch(setGGNotUpdateValutationNote(text))}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                        <Button
                            variant="solid"
                            color="orange"
                            size="md"
                            iconPosition="off"
                            label="Salva"
                            onClick={() => dispatch(GGNotificationUpdate({ body: ggNotificationState.ggNotificationUpdateRequest, id: ggNotificationState.ggNotificationIdToUpdate }))}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}